module.exports = __webpack_public_path__ + "img/slide-left.6f283755.svg";